import { render, staticRenderFns } from "./shrinkableMenu.vue?vue&type=template&id=1e3f7cb1"
import script from "./shrinkableMenu.vue?vue&type=script&lang=js"
export * from "./shrinkableMenu.vue?vue&type=script&lang=js"
import style0 from "./shrinkableMenu.vue?vue&type=style&index=0&id=1e3f7cb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports